// extracted by mini-css-extract-plugin
module.exports = {"LinkCard":"LinkDetailsView_LinkCard__d3VK4"};